import React, { Component } from 'react'

import cn from 'classnames'
import s from './Overlay.scss'
import sLay from 'styles/modules/layout.scss'

export default class Overlay extends Component {
  render() {
    const { children, color, translucent, transparent, style } = this.props
    return (
      <div
        className={cn(
          s.overlay,
          {
            [s.primary]: color === 'primary',
            [s.translucent]: translucent,
            [s.transparent]: transparent,
            [s.dark]: color === 'dark',
          },
          sLay['layout-column'],
          sLay['layout-align-center-center']
        )}
        style={style}
      >
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Overlay/Overlay.jsx